<template>
  <div class="content-wrap">
    <transition name="fade">
      <stage-countdown
        v-if="stage === 'countdown'"
        :key="stage"
      ></stage-countdown>
      <stage-results
        v-else-if="stage === 'results'"
        :key="stage"
      ></stage-results>
      <stage-race
        v-else-if="stage === 'race'"
        :key="stage"
      ></stage-race>
    </transition>
  </div>
</template>

<script>
import StageCountdown from './StageCountdown';
import StageResults from './StageResults';
import StageRace from './StageRace';

export default {
  name: 'AppContent',
  components: {
    StageCountdown,
    StageResults,
    StageRace,
  },
  props: {
    stage: {
      type: String,
      default: '',
    },
  },
  computed: {
  },
};
</script>

<style lang="scss">
.content-wrap {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: calc(100vh - #{$header-height} - 3px);
  overflow: hidden;
  white-space: nowrap;
}
.screen-content {
  display: inline-block;
  position: relative;
  width: 100%;
  height: 100%;
  margin-right: 10%;
}

.stream-runner-mode {
  .content-wrap {
    height: calc(100vh - #{$header-height-xl} - 3px);
  }
}

@media screen and (min-width: $breakpoint-mobile) {

  // .content-wrap {
  //   height: calc(100vh - #{$header-height-md} + 3px);
  // }
}

@media screen and (min-width: $breakpoint-desktop) {

  // .content-wrap {
  //   height: calc(100vh - get-vw(#{$header-height}) + 3px);
  //   padding: 10.4vh 4.3vw 9.4vh;
  // }
}
</style>
